import { render, staticRenderFns } from "./SaiHuCommon.vue?vue&type=template&id=33814546&"
import script from "./SaiHuCommon.vue?vue&type=script&lang=js&"
export * from "./SaiHuCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports